import React from "react";
import { Calendar, Modal, Spinner } from "react-rainbow-components";
import { ModalProps } from "react-rainbow-components/components/Modal";
import { generateCoupon } from "../../services/coupon.service";
import {
  ButtonContainer,
  ButtonCreateAdmin,
  InputAdmin,
  InputLabel,
  Title,
} from "../common/FormComponent";

const ModalCreateCodeCoupon = (
  props: ModalProps & { couponId: string; fetchData: () => void }
) => {
  const initialState = { date: new Date() };
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [numberCode, setNumberCode] = React.useState<number>(1);
  const [datePicker, setDatePicker] =
    React.useState<{ date: Date | string }>(initialState);
  const hadleGeneratedCode = async () => {
    try {
      setIsLoading(true);
      for (let index = 0; index < numberCode; index++) {
        await generateCoupon(props.couponId, datePicker.date);
      }
      setIsLoading(false);
      props.onRequestClose && props.onRequestClose();
      props.fetchData();
    } catch (error) {}
  };
  return (
    <Modal {...props}>
      {!isLoading ? (
        <>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Title>สร้างรหัสคูปอง</Title>
            <InputLabel>จำนวนรหัสคูปอง</InputLabel>
            <InputAdmin
              placeholder="จำนวนรหัสคูปอง"
              type="number"
              value={numberCode}
              onChange={(e: any) => setNumberCode(+e.target.value)}
            />
            <InputLabel>วันหมดอายุรหัสคูปอง</InputLabel>
            <div>
              <div className="rainbow-align-content_center rainbow-p-vertical_xx-large rainbow-p-horizontal_medium">
                <Calendar
                  id="calendar-3"
                  value={datePicker.date}
                  minDate={new Date()}
                  onChange={(value) => setDatePicker({ date: value })}
                />
              </div>
            </div>
          </div>
          <ButtonContainer>
            <ButtonCreateAdmin
              value="สร้างรหัสคูปอง"
              onClick={hadleGeneratedCode}
            />
          </ButtonContainer>
        </>
      ) : (
        <Spinner />
      )}
    </Modal>
  );
};

export default ModalCreateCodeCoupon;
